import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Modal, Segment } from "semantic-ui-react";
import { useCreateRecipe } from "../../api/recipeSimulator";
import CommonModalCloseIcon from "../../assets/commonIcon/CommonModalCloseIcon";
import { InputText } from "../InputText/InputText";
import { InputTextArea } from "../InputText/InputTextArea";
import MainBottomMultipleButtonView from "../mainBottomButtonView/MainBottomMultipleButtonView";

const AddRecipeModal = ({ closeModal = () => {} }: any) => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: "all",
    defaultValues: {
      recipeName: "",
      notes: ""
    }
  });

  const { mutate: createRecipe, isLoading } = useCreateRecipe();

  const onSubmit = (data: any) => {
    const dataToSubmit = {
      recipeName: data.recipeName.trim(),
      notes: data.notes.trim()
    };
    createRecipe(dataToSubmit, {
      onSuccess: (newRecipe: any) => {
        if (newRecipe && newRecipe._id) {
          navigate(`/recipe-simulator/${newRecipe._id}/manage`);
        }
      }
    });
  };

  return (
    <Modal
      centered={false}
      size={"small"}
      open={true}
      onClose={() => closeModal()}
      className="custom-modal"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Content as={Segment}>
          <>
            <div className="modal-header">
              Add a New Recipe
              <CommonModalCloseIcon onClick={closeModal} className="close-icon" />
            </div>
            <div className="modal-content">
              <InputText
                labelName={"Recipe Name*"}
                errorMessage="Recipe Name is required"
                name="recipeName"
                register={register}
                errors={errors.recipeName}
                required
              />
              <InputTextArea
                labelName={"Note/Description"}
                errorMessage="Notes are required"
                name="notes"
                register={register}
              />
              <div style={{ marginBottom: "-1rem" }}></div>
              <MainBottomMultipleButtonView
                leftButtons={[
                  {
                    title: "Cancel",
                    onClick: () => closeModal(),
                    buttonOutLine: true
                  }
                ]}
                rightButtons={[
                  {
                    contentView: 16,
                    title: "Save",
                    onClick: () => {},
                    type: "submit",
                    buttonView: true
                  }
                ]}
              />
            </div>
          </>
        </Modal.Content>
      </form>
    </Modal>
  );
};

export default AddRecipeModal;
